import { render, staticRenderFns } from "./assets-details.vue?vue&type=template&id=5d85156a&scoped=true&"
import script from "./assets-details.vue?vue&type=script&lang=js&"
export * from "./assets-details.vue?vue&type=script&lang=js&"
import style0 from "./assets-details.vue?vue&type=style&index=0&id=5d85156a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d85156a",
  null
  
)

export default component.exports